import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Option, OptGroup } from 'rc-select';
import { ConfigContext } from '../config-provider';
import AnimationContext from '../config-provider/AnimationContext';
import SizeContext from '../config-provider/SizeContext';
// import { Select as AntdSelect, SelectProps as AntdSelectProps } from 'antd';
import AntdSelect from 'antd/es/select/index';
import { SelectValue, InternalSelectProps, LabeledValue } from 'antd/es/select/index';
import warning from 'antd/es/_util/warning';
import { Icon } from '../icon';
const SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const InnerSelect = (props, ref) => {
    const { children, className, suffixIcon, removeIcon, clearIcon, inputPrefix, inputSuffix, size: customizeSize = 'middle', showArrow = true, menuItemSelectedIcon = null, onChange, dropdownClassName, prefixCls: customizePrefixCls, ...otherProps } = props;
    const { defaultOpen, mode, showSearch, id, onDropdownVisibleChange } = props;
    if (process.env.NODE_ENV !== 'production')
        warning(props.bordered !== false, 'select', `'bordered = false' is deprecated now`);
    warning(props.theme !== 'gray', 'select', `'themes = gray' is deprecated now`);
    const [isOpen, setIsOpen] = React.useState(defaultOpen !== undefined ? defaultOpen : false);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const animation = React.useContext(AnimationContext);
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // 增加 xs size
    const size = React.useContext(SizeContext);
    const mergedSize = customizeSize || size;
    const mergedClassName = classNames(className, {
        [`${prefixCls}-xs`]: mergedSize === 'xs'
    });
    if (mergedSize !== 'xs') {
        otherProps.size = mergedSize;
    }
    const mergedDropdownClassname = classNames(dropdownClassName, {
        'glassmorphism glassmorphism-dropdown': !!animation.glassmorphism
    });
    // 在各mode中默认显示suffixIcon （showArrow = true）
    // 展开dropdown菜单时，suffixIcon默认显示Chevron Up；菜单收起时为Chevron Down。
    // 存在showSearch时，展开dropdown菜单时suffixIcon默认为Search Icon。
    const suffixIconWhenDropdownVisible = showSearch ? 'search' : 'chevron--down';
    const suffixIconWhenDropdownInvisible = 'chevron--down';
    const iconType = isOpen ? suffixIconWhenDropdownVisible : suffixIconWhenDropdownInvisible;
    const mergedSuffixIcon = suffixIcon ? suffixIcon : React.createElement(Icon, { className: `${prefixCls}-suffix`, type: iconType });
    const mergedRemoveIcon = removeIcon ? removeIcon : React.createElement(Icon, { type: 'close' });
    const mergedClearIcon = clearIcon ? clearIcon : React.createElement(Icon, { type: 'close' });
    const mergedOnDropdownVisibleChange = (open) => {
        setIsOpen(open);
        if (typeof onDropdownVisibleChange === 'function') {
            onDropdownVisibleChange(open);
        }
    };
    // 在single mode中，如果存在inputPrefix或者inputSuffix，通过DOM操作放置在.${prefixCls}-selection-search-input INPUT Element附近。
    // 确保存在id属性传入Antd Select组件，用于query INPUT Element。
    if (id === undefined) {
        const currentDate = new Date().valueOf().toString();
        otherProps.id = `${prefixCls}-input-${currentDate}`;
    }
    React.useEffect(() => {
        /**
         * Select DOM 结构和改动参考
         * <div class="${prefixCls}-selector">
         *     新增InputPrefix ==> <Comp className="${prefixCls}-selection-prefix">
         *     <span class="${prefixCls}-selection-search">
         *       新增InputPrefix ==> <Comp className="${prefixCls}-selection-search-prefix">
         *       <input id="${id}" class="${prefixCls}-selection-search-input" />
         *       新增InputSuffix ==> <Comp className="${prefixCls}-selection-search-suffix">
         *     </span>
         *     <span class="${prefixCls}-selection-placeholder"></span>
         * </div>
         *
         * 新增2处InputPrefix用于对齐INPUT Element的位置。
         */
        // single mode
        if (mode !== 'multiple' && mode !== 'tags') {
            const searchInput = document.querySelector(`input#${otherProps.id}`);
            if (!searchInput)
                return;
            const searchSpan = searchInput.parentElement;
            const selectorDiv = searchSpan?.parentElement;
            if (inputPrefix) {
                const sectionPrefixClass = `${prefixCls}-selection-prefix`;
                const searchPrefixClass = `${prefixCls}-selection-search-prefix`;
                selectorDiv?.querySelector(`.${sectionPrefixClass}`)?.remove();
                selectorDiv?.querySelector(`.${searchPrefixClass}`)?.remove();
                const newNode = document.createElement('span');
                newNode.className = sectionPrefixClass;
                if (typeof inputPrefix === 'string') {
                    newNode.innerText = inputPrefix;
                    selectorDiv.insertBefore(newNode.cloneNode(true), searchSpan);
                    newNode.className = searchPrefixClass;
                    searchSpan.insertBefore(newNode.cloneNode(true), searchSpan.firstChild);
                }
                else if (React.isValidElement(inputPrefix)) {
                    const sectionPrefixNode = newNode.cloneNode(true);
                    ReactDOM.render(inputPrefix, sectionPrefixNode);
                    selectorDiv.insertBefore(sectionPrefixNode, searchSpan);
                    newNode.className = searchPrefixClass;
                    const searchPrefixNode = newNode.cloneNode(true);
                    ReactDOM.render(inputPrefix, searchPrefixNode);
                    searchSpan.insertBefore(searchPrefixNode, searchSpan.firstChild);
                }
            }
            if (inputSuffix) {
                const sectionSuffixClass = `${prefixCls}-selection-suffix`;
                const searchSuffixClass = `${prefixCls}-selection-search-suffix`;
                selectorDiv?.querySelector(`.${sectionSuffixClass}`)?.remove();
                selectorDiv?.querySelector(`.${searchSuffixClass}`)?.remove();
                const newNode = document.createElement('span');
                newNode.className = `${sectionSuffixClass} g-layout-margin-left-2`;
                if (typeof inputSuffix === 'string') {
                    newNode.innerText = inputSuffix;
                    selectorDiv.appendChild(newNode.cloneNode(true));
                    newNode.className = `${searchSuffixClass} g-layout-margin-left-2`;
                    searchSpan.appendChild(newNode.cloneNode(true));
                }
                else if (React.isValidElement(inputSuffix)) {
                    const sectionSuffixNode = newNode.cloneNode(true);
                    ReactDOM.render(inputSuffix, sectionSuffixNode);
                    selectorDiv.appendChild(sectionSuffixNode);
                    newNode.className = `${searchSuffixClass} g-layout-margin-left-2`;
                    const searchSuffixNode = newNode.cloneNode(true);
                    ReactDOM.render(inputSuffix, searchSuffixNode);
                    searchSpan.appendChild(searchSuffixNode);
                }
            }
        }
    }, [otherProps.id, mode, inputPrefix, inputSuffix]);
    const [value, setValue] = React.useState([]);
    const mergeOnChange = (value, option) => {
        setValue(value);
        if (typeof onChange === 'function') {
            onChange(value, option);
        }
    };
    // 在multiple mode时，当overflow item多于搜索框，给搜索框增加阴影。
    React.useLayoutEffect(() => {
        if (mode === 'multiple' || mode === 'tags') {
            const searchInput = document.querySelector(`input#${otherProps.id}`);
            if (!searchInput)
                return;
            const overflowElement = searchInput.parentElement?.parentElement?.parentElement;
            if (!overflowElement)
                return;
            if (overflowElement.scrollWidth > overflowElement.clientWidth) {
                overflowElement.classList.add(`${prefixCls}-selection-overflow-with-shadow`);
            }
            else {
                overflowElement.classList.remove(`${prefixCls}-selection-overflow-with-shadow`);
            }
        }
    }, [mode, value]);
    if (props.bordered === false) {
        otherProps.bordered = true;
    }
    return (React.createElement(AntdSelect, { ref: ref, prefixCls: prefixCls, transitionName: `${rootPrefixCls}-slide-up`, className: mergedClassName, dropdownClassName: mergedDropdownClassname, showArrow: showArrow, suffixIcon: mergedSuffixIcon, removeIcon: mergedRemoveIcon, clearIcon: mergedClearIcon, menuItemSelectedIcon: menuItemSelectedIcon, onChange: mergeOnChange, onDropdownVisibleChange: mergedOnDropdownVisibleChange, ...otherProps }, children));
};
// 从 Antd 拷贝未导出的 types
const SelectRef = React.forwardRef(InnerSelect);
// const ConfiguredOption = withConfigProvider(Option);
// const ConfiguredOptGroup = withConfigProvider(OptGroup);
const ConfiguredOption = Option;
const ConfiguredOptGroup = OptGroup;
const Select = SelectRef;
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select.Option = ConfiguredOption;
Select.OptGroup = ConfiguredOptGroup;
// const ConfiguredSelect = withConfigProvider(Select);
const ConfiguredSelect = Select;
export { ConfiguredSelect as Select };
export default ConfiguredSelect;
